// @ts-strict-ignore
import { LabelEditorUtils } from '@project/components/label/label-editor/label-editor-utils';
import { Dictionary } from 'typescript-collections';
import { ArticleTypeIds } from '@article/constants/article-type-ids';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { DefaultTextParameters } from '@project/components/label/label-editor/default-text-parameters';
import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class DefaultTextParametersManager {

  private readonly articleTypeIdToDefaultTextParameters = new Dictionary<number, DefaultTextParameters>();
  private readonly defaultTextParameters: DefaultTextParameters = new DefaultTextParameters(LabelEditorUtils.DEFAULT_FONT_SIZE, true);

  public constructor() {
    this.articleTypeIdToDefaultTextParameters.setValue(ArticleTypeIds.MULTI_CONNECTORS, new DefaultTextParameters(7, true));
  }

  public getDefaultTextParameterByArticleContainer(container: ArticleContainer): DefaultTextParameters {
    if (!container || !container.article || !container.article.type) {
      return null;
    }
    return this.getDefaultTextParameterByArticleTypeId(container.article.type.id);
  }

  public getDefaultTextParameterByArticleTypeId(articleTypeId: number): DefaultTextParameters {
    if (this.articleTypeIdToDefaultTextParameters.containsKey(articleTypeId)) {
      return this.articleTypeIdToDefaultTextParameters.getValue(articleTypeId);
    }
    return this.defaultTextParameters;
  }
}
